import React from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';

import FullScreenLoader from '../../../../components/global/FullScreenLoader';
import ContributorBusinessCardModal from '../../../../components/global/ContributorBusinessCard';
import { isNativeAppWebView } from '../../../../services/native-bridge/native-apps-interface';

const StandaloneWeddingsBusinessCard = () => {
  const history = useHistory();
  const match = useRouteMatch();
  const { accountId } = match?.params ?? {};

  if (!accountId) {
    return <FullScreenLoader />;
  }

  return (
    <ContributorBusinessCardModal
      forceOpen
      accountId={accountId}
      onClose={
        !isNativeAppWebView() || history.length > 1
          ? () => {
              history.goBack();
            }
          : undefined
      }
    />
  );
};

export default StandaloneWeddingsBusinessCard;
